import { render, staticRenderFns } from "./DealIndex.vue?vue&type=template&id=72184caf"
import script from "./DealIndex.vue?vue&type=script&lang=ts"
export * from "./DealIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports